import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ResourceName, navigateWithFilters } from 'utils';
import { FilterableProperties } from 'utils';
import { TableActions, TableColumn } from 'utils';
import {
  CTX_ADMIN_ROUTES,
  CryptlexApiService,
  OrganizationFormComponent,
} from 'ng-ui';
import { DataCacheService } from 'ng-ui';
import { ResourceTableService } from 'ng-ui';
import { SEARCH_STRINGS } from 'utils';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AdminOrganizationService extends ResourceTableService {
  override resourceApiPath = '/v3/organizations';
  override resourceName: ResourceName = 'organization';

  override tableSearchPlaceholder = SEARCH_STRINGS.name;
  override creationComponent = OrganizationFormComponent;
  override updationComponent = OrganizationFormComponent;
  override tableEmptyMessage =
    'You have not created any Organizations. Organizations allow you to delegate user management to ';
  override selections = new SelectionModel<any>(true, []);
  override filterableProperties: FilterableProperties = {
    name: 'objectString',
    email: 'objectString',
    resellerId: 'reseller',
  };

  override actions: TableActions = {
    read: true,
    create: true,
    update: true,
    delete: true,
    export: false,
    tag: false,
    search: true,
    selection: true,
    segments: true,
    menuActions: [
      {
        label: 'Edit',
        callback: this.launchUpdationDialog.bind(this),
        icon: 'EDIT',
        disabled: () => {
          return !this.writeAllowed;
        },
      },
      {
        label: 'View Licenses',
        callback: this.navigateToLicenses.bind(this),
        icon: 'NAVIGATE_TO',
      },
      {
        label: 'View Users',
        callback: this.navigateToUsers.bind(this),
        icon: 'NAVIGATE_TO',
      },
      {
        label: 'Delete',
        callback: this.launchDeletionDialog.bind(this),
        icon: 'DELETE',
        disabled: () => {
          return !this.deleteAllowed;
        },
      },
    ],
  };

  override columns: TableColumn[] = [
    { displayType: 'name', property: 'name' },
    { displayType: 'text', property: 'email' },
    { property: 'reseller.name', displayType: 'text' },
    { displayType: 'truncateText', property: 'description' },
    { displayType: 'unlimitedCheck', property: 'allowedUsers' },
    { displayType: 'text', property: 'address.country' },
    { displayType: 'text', property: 'address.city' },
    { displayType: 'text', property: 'address.state' },
    { displayType: 'text', property: 'address.postalCode' },
    { displayType: 'text', property: 'address.addressLine1' },
    { displayType: 'text', property: 'address.addressLine2' },
    {
      property: 'updatedAt',
      displayType: 'date',
    },
  ];
  _columnIdsToDisplay: string[] = [
    'name',
    'email',
    'description',
    'address.country',
    'reseller.name',
  ];
  constructor(
    apiService: CryptlexApiService,
    dialog: MatDialog,
    dataCacheService: DataCacheService,
    router: Router,
    permissionsService: PermissionsService
  ) {
    super(apiService, dialog, dataCacheService, router, permissionsService);
  }

  /** Navigate to licenses with filter for organization */

  async navigateToLicenses(organization: any) {
    await navigateWithFilters(
      [
        {
          property: 'organizationId',
          value: organization.id,
          operator: 'eq',
          displayValue: organization.name,
        },
      ],
      this.router,
      CTX_ADMIN_ROUTES.getUrl('licenses')
    );
  }

  /** Navigate to Users with filter for organization */
  async navigateToUsers(organization: any) {
    await navigateWithFilters(
      [
        {
          property: 'organization.name',
          value: organization.name,
          operator: 'eq',
        },
      ],
      this.router,
      CTX_ADMIN_ROUTES.getUrl('users')
    );
  }
}
